import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { convertDateFromServer } from 'app/shared/util/date-utils';
import ViewTable from 'app/shared/view-table/view-table';
import ViewTableHeaderColumn from 'app/shared/view-table/view-table-header-column';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CaseConstructionLegalityDocumentsDeleteModal from 'app/edozvola/cases/case-construction-legality/documents/case-construction-legality-documents-delete-modal';
import { fetchCaseConstructionLegalityDocumentsQuery } from 'app/edozvola/cases/case-construction-legality/service/case-construction-legality.queries';
import { TABLE_QUERY_KEYS } from 'app/config/constants';
import { getInvalidRowsForTable } from 'app/shared/util/validation-errors.util';
import { CaseConstructionLegalityDocumentAddFormModel } from 'app/edozvola/cases/case-construction-legality/model/case-construction-legality.model';
import { getCaseContext } from 'app/shared/util/context-util';
import { TooltipWrapper } from 'edozvola-frontend-lib/dist/ui/components/tooltipwrapper';

export interface ICaseConstructionLegalityDocumentsTableProps {
  onRowClick: (string) => void;
  editConstructionLegalityDocumentDisabled: boolean;
}

const CaseConstructionLegalityDocumentsTable = (props: ICaseConstructionLegalityDocumentsTableProps) => {
  const { id } = useParams<{ id: string }>();
  const [modalOpened, setModalOpened] = useState(false);
  const [webIdToDelete, setWebIdToDelete] = useState('');
  const { sidebarItemPair } = getCaseContext();

  const invalidRowIds = getInvalidRowsForTable(TABLE_QUERY_KEYS.CASE_CONSTRUCTION_LEGALITY_DOCUMENTS_TABLE);

  const deleteDocument = (webId: string) => {
    setWebIdToDelete(webId);
    setModalOpened(true);
  };

  const cancelDocumentDeletion = () => {
    setWebIdToDelete('');
    setModalOpened(false);
  };

  const renderUserTableRow = (value: CaseConstructionLegalityDocumentAddFormModel, caseIndex: number) => {
    return (
      <tr key={caseIndex} className={invalidRowIds.includes(value.webId) ? 'hand invalid-table-row' : 'hand'}>
        <td>
          <div className={'column-with-multiple-data'}>
            <span>{value.webId}</span>
            <span>{value.finalActDocumentName}</span>
          </div>
        </td>
        <td>
          <div className={'column-with-multiple-data'}>
            <span>{value.classification}</span>
            <span>{value.finalActFileNumber}</span>
          </div>
        </td>
        <td>{convertDateFromServer(value.finalDocumentAdmissionDate)}</td>
        <td>{convertDateFromServer(value.executionDate)}</td>
        <td>{convertDateFromServer(value.effectivenessDate)}</td>
        <td>
          <div className={'actions-container'}>
            {sidebarItemPair?.canView && (
              <TooltipWrapper message={'Pregledaj'}>
                <FontAwesomeIcon
                  icon={'eye'}
                  className={'icon-table'}
                  onClick={() => props.onRowClick(value.idCaseConstructionLegalityDocumentMap)}
                />
              </TooltipWrapper>
            )}
            {sidebarItemPair?.canDelete && props.editConstructionLegalityDocumentDisabled === false && (
              <TooltipWrapper message={'Obriši'}>
                <FontAwesomeIcon
                  icon={'trash'}
                  className={'icon-table'}
                  onClick={() => deleteDocument(value.idCaseConstructionLegalityDocumentMap)}
                />
              </TooltipWrapper>
            )}
          </div>
        </td>
      </tr>
    );
  };

  return (
    <>
      <ViewTable
        initialPaginationColumn={'webId'}
        renderTableRow={renderUserTableRow}
        fetchDataQuery={fetchCaseConstructionLegalityDocumentsQuery}
        fetchDataProps={id}
        noDataMessage={'Nema akata kojima se dokazuje legalnost.'}
      >
        <ViewTableHeaderColumn renderSort sortKey={'webId'} columnLabels={['Šifra predmeta', 'Naziv akta']} />
        <ViewTableHeaderColumn renderSort sortKey={'classification'} columnLabels={['Klasifikacijska oznaka', 'Urudžbeni broj']} />
        <ViewTableHeaderColumn renderSort sortKey={'solutionDate'} columnLabels={['Datum rješavanja']} />
        <ViewTableHeaderColumn renderSort sortKey={'executionDate'} columnLabels={['Datum izvršnosti']} />
        <ViewTableHeaderColumn renderSort sortKey={'effectivenessDate'} columnLabels={['Datum pravomoćnosti']} />
        <ViewTableHeaderColumn renderSort={false} columnLabels={['Akcije']} width={'75px'} />
      </ViewTable>
      <CaseConstructionLegalityDocumentsDeleteModal
        isModalOpen={modalOpened}
        closeModalCallback={cancelDocumentDeletion}
        documentWebId={webIdToDelete}
      />
    </>
  );
};

export default CaseConstructionLegalityDocumentsTable;
